<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">
    <!-- 重要指标 -->
    <!-- <index-common
      v-if="page.isIndex"
      v-loading="loading.indexLoading"
      element-loading-background="#FFF"
      element-loading-spinner="el-icon-loading"
      element-loading-customClass="defineLoading"
      element-loading-text="拼命的加载中"
      class="block-preview noCompare_min"
      :options = "summaryList">
    </index-common> -->
    <!-- 趋势图 -->
    <chart-content>
       <div class="flex-between gragh-index">
          <!-- 图的指标 -->
          <SelectIndex
            :class-key="page.chartKey"
            :number="page.chartNum"
            :address="page.chartAddress"
            >
          </SelectIndex>
        </div>
      <div >
        <div v-for="(item,index) in list" :key="index" style="float:left;width:46%;margin-right:30px;">
        <VueColumn
          id="chart"
          v-loading="item.chartLoading"
          element-loading-background="#FFF"
          element-loading-spinner="el-icon-loading"
          element-loading-customClass="defineLoading"
          element-loading-text="拼命的加载中"
          style="height:400px"
          :options="item.option">
        </VueColumn>
      </div>
      </div>
    </chart-content>
  </div>
</template>

<script>

import * as Api from '../../../common/report.api'
import * as queryUtil from '../../../common/query'
import * as classCharts from '../chart/style_charts'
export default {
  components: {
    ChartContent: (resolve) => require(['./chart-content'], resolve),
    // 图指标不分类
    SelectIndex: (resolve) => require(['../select/select_index'], resolve),
    // 柱状图
    VueColumn: () => import('../chart/vue-column')
  },
  props: {
    page: [Object],
    header: [Object],
    headerShow: [Array],
    keyList: [Array]
  },
  data () {
    return {
      list: [],
      indexLists: []
    }
  },
  created () {
    this.keyList.forEach(item => {
      this.list.push({
        chartLoading: false,
        option: {}
      })
    })
  },
  computed: {
    queryChart () {
      let chart = {}
		  chart = Object.assign(
        {},
        chart,
        this.$store.state.query_data,
        this.$store.state.query_common
      )
      return this.getChart(chart)
    }
  },
  watch: {
    queryChart () {
    }
  },
  methods: {
    // 查询表格和重要指标
    // getTable (params) {
    //   // console.log(params);
    //   if (this.$route.name === this.page.name && Object.keys(params).indexOf('indicatorIDs') >= 0 && this.page.isIndex) {
    //     Func.getIndex(this,params)
    //     return params
    //   }
    // },
    // 查询chart
    async getChart (params) {
      if (this.$route.name === this.page.name && Object.keys(params).indexOf('indicatorIDs') >= 0) {
        queryUtil.changeParams(this.headerShow, params, this.page.tableTitle, this.header.contrast)
        queryUtil.changeTrendParams(params)
        params.constantType = this.page.ChartconstantType
        // arr.forEach不可以异步
        for (let i = 0; i < this.keyList.length; i++) {
          params.constantKey = this.keyList[i].constantKey
          // params.identifyKey=this.keyList[i].identifyKey
          try {
            await this.getCloumnOne(this.list[i], params)
          } catch (err) {
            // console.log(err);
          }
        }
		  } else {
        return {}
      }
      return params
    },
    getCloumnOne (ele, params) {
      return new Promise((resolve, reject) => {
        ele.chartLoading = true
        Api.getTrendOne(params).then(res => {
          ele.chartLoading = false
          if (res.data && res.data.errorCode === 0 && res.data.data) {
            // let a = res.data.data
            // let data = way.sortTwoData(a)
            let column = queryUtil.setTrendSerise(res.data.data)
            ele.option = Object.assign({}, ele.option, classCharts.chartColumn(column))
            resolve()
          } else {
            ele.option = Object.assign({}, ele.option, classCharts.chartColumn({'series': []}))
            reject(res)
          }
        }).catch(err => { reject(err) })
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
